import { Calendar } from 'primereact/calendar';
import { TabView, TabPanel } from 'primereact/tabview';
import React, { useState, useEffect } from 'react'
import ResumenVentasAnual from './ResumenVentasAnual';
import ResumenVentasMensual from './ResumenVentasMensual';
import ResumenVentasSemanal from './ResumenVentasSemanal';
import { setTitlePage } from '../../../Base/Services/Config/ConfigService';

const ResumenVentasScreen = ({kpiGerencia, fecha, getInfo}) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const [date, setDate] = useState(new Date());

    useEffect(() => {
        setTitlePage('Resumen Ventas')
    }, [])

    return (
        <div className='' style={{ width:'100%' }}>
            {!kpiGerencia && <div className='d-flex px-3 pt-3 align-items-center '>
                <Calendar value={date} onChange={(e) => setDate(e.value)} view="month" dateFormat="mm/yy" showIcon />
            </div>}
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}  >
                <TabPanel header='Anual'>
                    <div>
                        <ResumenVentasAnual kpiGerencia={kpiGerencia} date={kpiGerencia ? fecha : date} getDatos={getInfo} />
                    </div>
                </TabPanel>
                <TabPanel header='Mensual'>
                    <div>
                        <ResumenVentasMensual kpiGerencia={kpiGerencia} date={kpiGerencia ? fecha : date} getDatos={getInfo} />
                    </div>
                </TabPanel>
                <TabPanel header='Semanal'>
                    <div>
                        <ResumenVentasSemanal kpiGerencia={kpiGerencia} date={kpiGerencia ? fecha : date} getDatos={getInfo} />
                    </div>
                </TabPanel>
            </TabView>
        </div>
    )
}

export default ResumenVentasScreen;